import { useState } from 'react';
import '../../styles/Home.css';
import KiteFestNav from '../../nav/KiteFestNav';

const KiteFest2025 = () => {

  return (




    <div className="container">
      <KiteFestNav ></KiteFestNav>
      <div>
        <h3 className="center-align"><b>Kite Fest 2025</b></h3>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/kiteFest/FBT.png" alt="" width="70%" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/kiteFest/kitefest.png" alt="" width="70%" className="rounded" /></p>
        </div>

      </div>

      <div>
        <h5 className="center-align"><a href="/"><b>For A Better Tomorrow (FBT)</b></a>  <b>Proudly Presents the 12<sup>th</sup> Annual Kite Fest!. </b></h5>
      </div>

      <div>
        <h5 className="justify c737373"></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >STEAM Race Winners</b></h4>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">1 - 3</td>
              <td className="center-align">Team : One More <br />
                Deeksha Sivakumar <br />
                Lakhith Sivakumar <br />
                Sharindaa Leoraj <br />
                Sharandaa Leoraj</td>
              <td className="center-align">Team : Fearless Fireflies <br />
                Saanvi Hemanth <br />
                Sharvika Dinesh Sonawane <br />
                Nishtha Tirpati <br />
                Sara Balaji</td>
              <td className="center-align">Team : Nerdy Gals <br />
                Diya Saggu <br />
                Poorvika Balivada <br />
                Venkata Dhanvika Busetty<br />
                Aaradhya Valadri </td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">4 - 5</td>
              <td className="center-align">Team : Adventure Kids <br />
                Nethra Arunvasagan <br />
                Sangamitra Arunvasagan <br />
                Shakshitha Selvakumar <br />
                Mithun Elancheziyan</td>
              <td className="center-align">Team : Tactical Thinkers <br />
                Sahasra Balivada <br />
                Adityaram SV <br />
                Niroshan Senthilkumar <br />
                Amruthavalli Goodalur Venkipuram</td>
              <td className="center-align">Team : Fantastic Four <br />
                Pahal Sheth <br />
                Kanishkaa Sri Vengala <br />
                Raya Maryam Hameed <br />
                Margi Kulkarni</td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">6 - 8</td>
              <td className="center-align">Team : Team Titans <br />
                Tej Shah <br />
                Neal Sheth <br />
                Shrihan Ayyalu <br />
                Chandra Padigala</td>
              <td className="center-align">Team : Code Divas <br />
                Digisha Sonawane <br />
                Dhiya Balaji <br />
                Divina David <br />
                Nidhi Shriram Patil</td>
              <td className="center-align">Team Univesal Elements <br />
                Smruthi <br />
                Niharika</td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Adult</td>
              <td className="center-align align-middle">NA</td>
              <td className="center-align">Team : Tactical Thinkers Moms <br />
                Sahana <br />
                Vidhya <br />
                Krithika <br />
                Chaitanya</td>
              <td className="center-align">Team : Bloom Girls <br />
                Kumari <br />
                Bhavana Gupta <br />
                Subha Anand Venkatesh <br />
                Sushmitha Nagarajan</td>
              <td className="center-align"></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Fun Games - Lemon & Spoon</b></h4>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">Age upto 5</td>
              <td className="center-align">Dhanwanth</td>
              <td className="center-align">Maha Didigam</td>
              <td className="center-align">Sai Arjun</td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">Age 6 to 8</td>
              <td className="center-align">Poorvika Balivada</td>
              <td className="center-align">Bala Vijay Veerappan</td>
              <td className="center-align">Sreethu Sriraman</td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">Age 9 to 11</td>
              <td className="center-align">Dhanesh S</td>
              <td className="center-align">Pradyun Didigam</td>
              <td className="center-align">Aadhya Kasmur</td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 4</td>
              <td className="center-align align-middle">Age 12 to 16</td>
              <td className="center-align">Divina David</td>
              <td className="center-align">Dhiya Balaji</td>
              <td className="center-align">Prajeet Kurella</td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Adult</td>
              <td className="center-align align-middle">NA</td>
              <td className="center-align">Kimmy</td>
              <td className="center-align">Saranya</td>
              <td className="center-align">Roshini <br />
                Tejaswari</td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

    </div>



  );
}
export default KiteFest2025;
